module.exports = __webpack_public_path__ + "img/conference-banner-pc-0522.cee221ec.png";